import { Divider, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Control, FieldErrors, UseFormRegister, UseFormReset, UseFormSetValue, } from "react-hook-form";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import WSButton from "../../Components/Button/WSButton";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "../../StateManagement/types";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import WSTextField, { CurrencyType, TextType } from "../../Components/TextBox/WSTextBox";
import WSDateField from "../../Components/DateField/WSDateField";
import WSTextAreaSuggestion from "../../Components/WSTextArea/WSTextAreaSuggestion";
import dayjs from "dayjs";
interface PartPaymentProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    partPaymentId?: string;
    setValue: UseFormSetValue<any>;
    onCancel: () => void
    workOrderId?: string
}

const DrawyerPartPayment: React.FC<PartPaymentProps> = ({
    control, id, register, partPaymentId, reset, setValue, onCancel, workOrderId
}) => {
    const [valueF, setValueF] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [cursor, setCursor] = useState(0);
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    useEffect(() => {
        const getPayment = async () => {
            try {
                
                const response: any = await callAPI(`Partpayment`, Method.GET, null, partPaymentId);
                if (response) {
                    setValue('amount', response?.amount)
                    setValue('partPaymentId', partPaymentId)
                     setValue('area', response?.area)
                      setValue('workOrderId', workOrderId)
                    // if (response?.description?.includes("@amount")) {


                    //     setValue('description', response?.description?.replace("@amount", `( ${response?.amount}/ )`))
                    // }
                     setValue('description', response?.description)
                    setValue('date', dayjs(response.date).format("MM-DD-YYYY"))

                }
            }
            catch (e) {
            }
        }
        if (partPaymentId) {
            getPayment();
        }
    }, [partPaymentId])
    const reduxComponentData = useSelector(
        (state: AppState) => state.components["PartPaymentSubmit"],
        shallowEqual
    );

    // Local state to store Redux data
    const [componentData, setComponentData] = useState(reduxComponentData);

    // Update useState when Redux state changes
    useEffect(() => {
        if (reduxComponentData) {
            setComponentData(reduxComponentData);
        }
    }, [reduxComponentData]);
    const placeholders = ["@amount", "@area"];

    const handleChange = (e: any) => {
        const val = e.target.value;
        setValueF(val);

        // detect when user types '@'
        const lastWord: any = val.slice(0, e.target.selectionStart).split(" ").pop();
        setShowSuggestions(lastWord?.startsWith("@"));
        setCursor(e.target.selectionStart || 0);
    };

    const handleSelect = (item: string) => {
        const before = valueF.slice(0, cursor);
        const after = valueF.slice(cursor);
        const newVal = before.replace(/@\w*$/, item) + after;
        setValueF(newVal);
        setShowSuggestions(false);
    };
    return (
        <Grid >
            {<Grid container spacing={2} mt={2}>
                <Grid item sm={6}>
                    <WSDateField
                        label="Date"
                        id="date"
                        dateFormat="DD-MM-YYYY"
                        setValue={setValue}
                        control={control}
                        rules={{ required: true }}
                        name="date" />
                </Grid>
                <Grid item sm={6}>
                    <WSTextField size="small"
                        label="Area"
                        id="area"
                        setValue={setValue}
                        control={control}
                        rules={{ required: false }}
                        name="area" />
                </Grid>
                <Grid item sm={6}>
                    <WSTextField size="small"
                        label="Amount"
                        id="amount"
                        setValue={setValue}
                        control={control}
                        rules={{ required: true }}
                        type={TextType.Currency}
                        currency={CurrencyType.Rupee}
                        name="amount" />
                </Grid>
                <Grid item xs={12}>
                    <WSTextAreaSuggestion
                        size="small"
                        label="Description"
                        id="description"
                        setValue={setValue}
                        control={control}
                        rules={{ required: true }}
                        name="description"
                        rows={4}
                    />
                    <WSHiddenField control={control} name="partPaymentId" defaultValue={partPaymentId} />
                    <WSHiddenField control={control} name="workOrderId" defaultValue={workOrderId} />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Divider />
                </Grid>
                <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton className="ws-theme-crm" loading={reduxComponentData?.data?.loading} variant="outlined" id='PartPaymentSubmit' label={"Save"} type="submit" size="medium" />
                    </Grid>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                    </Grid>
                </Grid>
            </Grid>
            }
        </Grid>
    );
};
export default DrawyerPartPayment;
